import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Box, useTheme, useViewportWidth } from '@xstyled/styled-components';
import ContactInfo from './ContactInfo';
import Navbar from './Navbar';
import Menu from './Menus/CategoryMenu';
import SearchBar from '@/Search/SearchBar';
import { FlexColCenter } from '@/UI/Primitives/FlexBox';
// import { CompareLarge } from '@/UI/Button/Compare';

export default function Header({ categories, isSearchPage }) {
  const theme = useTheme();
  const width = useViewportWidth();

  const router = useRouter();
  const path = router.pathname;

  const [bg, setBg] = useState(theme.colors['blue-100']);

  useEffect(() => {
    if (
      !(
        width >= 1024 &&
        (path === '/' || path === '/brands/[brand]' || path === '/kvartal')
      )
    ) {
      setBg(theme.colors.white);
    }
  }, [path, width, theme.colors]);

  return (
    <Box
      as="header"
      bg={bg}
      p={{ _: '1.25rem 1rem 0 1rem', desktop: '6rem 2rem 2rem' }}
    >
      <ContactInfo />

      <Navbar />

      {/* Mobile */}
      <FlexColCenter
        display={{ _: 'flex', desktop: 'none' }}
        spaceY="1rem"
        mb="2rem"
      >
        <SearchBar isSearchPage={isSearchPage} />
        {/* <CompareLarge /> */}
      </FlexColCenter>

      {/* Desktop */}
      <Menu categories={categories} />
    </Box>
  );
}
